import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class EvaluationNote extends BaseService {
  constructor() {
    super("evaluation-note");
  }

  createEvaluationNote = (data) => getResponseQuery(super.insert(data));

  updateEvaluationNote = (evaluationNote) =>
    getResponseQuery(super.updateById(evaluationNote));

  deleteEvaluationNote = (evaluationNoteId) =>
    getResponseQuery(super.deleteById(evaluationNoteId));

  getEvaluationNote = (enterpriseId, employerId) =>
    getResponseQuery(
      http.get(`${this.path}/get/${enterpriseId}/${employerId}`)
    );
}

export default new EvaluationNote();
